module.exports = __webpack_public_path__ + "static/img/empty.ca44d2ff.png";